<!-- BDV ASYNC MANAGEMENT FUNCIONAL -->
<div class="container-fluid py-4">
  
  <!-- Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <button class="btn btn-outline-secondary me-3" (click)="goBack()">
            <i class="fas fa-arrow-left me-1"></i>
            Volver
          </button>
          <h2 class="d-inline">
            <i class="fas fa-university text-primary me-2"></i>
            Gestión Async BDV
          </h2>
        </div>
        <button class="btn btn-outline-primary" (click)="loadAsyncStatus()" [disabled]="loading">
          <i class="fas fa-sync-alt me-1" [class.fa-spin]="loading"></i>
          Actualizar
        </button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading && !asyncStatus" class="text-center py-5">
    <div class="spinner-border text-primary" role="status"></div>
    <p class="text-muted mt-2">Cargando configuraciones BDV...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="alert alert-danger">
    <i class="fas fa-exclamation-triangle me-2"></i>
    {{ error }}
    <button class="btn btn-sm btn-outline-danger ms-2" (click)="loadAsyncStatus()">
      Reintentar
    </button>
  </div>

  <!-- Panel Principal -->
  <div *ngIf="asyncStatus">
    
    <!-- Estado y Control Principal -->
    <div class="row mb-4">
      <div class="col-12 col-lg-8 offset-lg-2">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0 text-white">
              <i class="fas fa-toggle-on me-2"></i>
              Control de Verificación Asíncrona
            </h5>
          </div>
          <div class="card-body">
            
            <!-- Indicador de Estado Grande -->
            <div class="text-center mb-4">
              <div class="status-indicator-large mb-3" 
                   [class.status-active]="asyncStatus.async_verification_enabled"
                   [class.status-disabled]="!asyncStatus.async_verification_enabled">
                <i class="fas" 
                   [class.fa-check-circle]="asyncStatus.async_verification_enabled"
                   [class.fa-times-circle]="!asyncStatus.async_verification_enabled"></i>
              </div>
              
              <h3 [class.text-success]="asyncStatus.async_verification_enabled" 
                  [class.text-danger]="!asyncStatus.async_verification_enabled">
                {{ asyncStatus.async_verification_enabled ? 'HABILITADO' : 'DESHABILITADO' }}
              </h3>
              
              <p class="text-muted mb-4">
                {{ asyncStatus.async_verification_enabled ? 
                   'Las transacciones fallidas se encolan para verificación asíncrona' : 
                   'Las transacciones fallidas devuelven error inmediato' }}
              </p>

              <!-- Toggle Button Principal -->
              <button 
                class="btn btn-lg px-5"
                [class.btn-success]="!asyncStatus.async_verification_enabled"
                [class.btn-danger]="asyncStatus.async_verification_enabled"
                (click)="toggleAsyncVerification()"
                [disabled]="loading">
                
                <i class="fas me-2" 
                   [class.fa-play]="!asyncStatus.async_verification_enabled"
                   [class.fa-stop]="asyncStatus.async_verification_enabled"
                   [class.fa-spinner]="loading"
                   [class.fa-spin]="loading"></i>
                   
                {{ loading ? 'Procesando...' : 
                   (asyncStatus.async_verification_enabled ? 'Deshabilitar Async' : 'Habilitar Async') }}
              </button>
            </div>

            <!-- Controles de Configuración -->
            <div class="row text-center">
              <div class="col-6">
                <div class="config-control-box">
                  <label class="config-label">Reintentos Máximos</label>
                  <div class="input-group input-group-lg justify-content-center">
                    <button class="btn btn-outline-secondary" (click)="changeRetryAttempts(asyncStatus.max_retry_attempts - 1)" [disabled]="loading || asyncStatus.max_retry_attempts <= 1">
                      <i class="fas fa-minus"></i>
                    </button>
                    <input 
                      type="number" 
                      class="form-control text-center fw-bold"
                      [value]="asyncStatus.max_retry_attempts"
                      min="1" 
                      max="50"
                      [disabled]="loading"
                      (blur)="onRetryAttemptsInputChange($event)"
                      style="max-width: 80px;">
                    <button class="btn btn-outline-secondary" (click)="changeRetryAttempts(asyncStatus.max_retry_attempts + 1)" [disabled]="loading || asyncStatus.max_retry_attempts >= 50">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                  <small class="text-muted">Intentos antes de marcar como TRASH</small>
                </div>
              </div>
              <div class="col-6">
                <div class="config-control-box">
                  <label class="config-label">Minutos entre Reintentos</label>
                  <div class="input-group input-group-lg justify-content-center">
                    <button class="btn btn-outline-secondary" (click)="changeRetryDelay(asyncStatus.retry_delay_minutes - 1)" [disabled]="loading || asyncStatus.retry_delay_minutes <= 1">
                      <i class="fas fa-minus"></i>
                    </button>
                    <input 
                      type="number" 
                      class="form-control text-center fw-bold"
                      [value]="asyncStatus.retry_delay_minutes"
                      min="1" 
                      max="60"
                      [disabled]="loading"
                      (blur)="onRetryDelayInputChange($event)"
                      style="max-width: 80px;">
                    <button class="btn btn-outline-secondary" (click)="changeRetryDelay(asyncStatus.retry_delay_minutes + 1)" [disabled]="loading || asyncStatus.retry_delay_minutes >= 60">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>
                  <small class="text-muted">Tiempo de espera entre verificaciones</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
